import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuex from './vuex'

import Element from 'element-ui'
import '/@/styles/elementReset.scss'

import Vant from 'vant'
import 'vant/lib/index.css'

import '/@/styles/global.scss'
import '/@/styles/vantReset.scss'
import '/@/styles/iconfont/iconfont.css'
import * as filters from '/@/filters' // global filters
import * as utils from '/@/utils' // global filters
import { getSessionStorage } from '/@/utils/storage'
const system = getSessionStorage('system')
if (system) {
  document.title = system.title
}
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.use(Vant)
Vue.use(Element)
Vue.prototype.$bus = new Vue()
Vue.prototype.$utils = utils
Vue.config.productionTip = false

// 忽略 Vue Devtools 的错误
window.addEventListener('unhandledrejection', event => {
  if (event.reason && event.reason.cmd === 'background-select-words-setContextMenus') {
    event.preventDefault()
  }
})

new Vue({
  el: '#app',
  router,
  store: vuex,
  render: h => h(App)
})
